// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-page {
  min-height: 100vh;
  background: #0A0A1B;
  padding: 2rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.profile-container {
  max-width: 800px;
  margin: 0 auto;
  background: transparent;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

/* Profile Header */
.profile-header {
  display: flex;
  align-items: center;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.05);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  gap: 1.5rem;
  backdrop-filter: blur(10px);
}

.avatar-large {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: #667eea;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 3px solid white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.avatar-letter {
  color: white;
  font-size: 2.5rem;
  font-weight: 600;
}

.user-info {
  flex: 1 1;
}

.user-name {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  background: linear-gradient(135deg, #7b3dd8 0%, #667eea 50%, #5606aa 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.02em;
}

.user-email {
  color: #94a3b8;
  font-size: 0.9rem;
}

/* Edit Controls */
.edit-controls {
  display: flex;
  gap: 0.5rem;
}

.edit-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem;
  background: transparent;
  color: #94a3b8;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s;
  width: 44px;
  height: 44px;
}

.edit-button:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #f1f5f9;
  transform: scale(1.05);
}

.edit-actions {
  display: flex;
  gap: 0.5rem;
}

.save-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.6rem 1.2rem;
  background: #10b981;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 500;
  transition: all 0.2s;
  min-width: 80px;
}

.save-button:hover:not(:disabled) {
  background: #059669;
  transform: translateY(-1px);
}

.save-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.cancel-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.6rem 1.2rem;
  background: #64748b;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 500;
  transition: all 0.2s;
  min-width: 80px;
}

.cancel-button:hover {
  background: #475569;
  transform: translateY(-1px);
}

/* Streak Section */
.streak-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.03);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.streak-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.streak-icon {
  width: 24px;
  height: 24px;
  color: #667eea;
}

.streak-info {
  display: flex;
  flex-direction: column;
}

.streak-number {
  font-size: 1.5rem;
  font-weight: 600;
  color: #f1f5f9;
  line-height: 1;
}

.streak-label {
  color: #94a3b8;
  font-size: 0.8rem;
}

/* Info Section */
.info-section {
  padding: 2rem;
  background: rgba(255, 255, 255, 0.02);
}

.info-section h2 {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 1rem;
  background: linear-gradient(135deg, #7b3dd8 0%, #667eea 50%, #5606aa 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.01em;
}

.info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.info-label {
  font-size: 0.8rem;
  color: #94a3b8;
  font-weight: 500;
}

.info-value {
  color: #f1f5f9;
  font-weight: 500;
}

/* Edit Form */
.edit-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group label {
  font-size: 0.9rem;
  font-weight: 500;
  color: #94a3b8;
}

.form-input {
  padding: 0.75rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  font-size: 0.9rem;
  transition: border-color 0.2s;
  background: rgba(255, 255, 255, 0.05);
  color: #f1f5f9;
}

.form-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-input::placeholder {
  color: #64748b;
}

.readonly-input {
  background: rgba(255, 255, 255, 0.02) !important;
  color: #94a3b8 !important;
  cursor: not-allowed;
  border-color: rgba(255, 255, 255, 0.1) !important;
}

/* Loading States */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  gap: 1rem;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #e2e8f0;
  border-top: 3px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-text {
  color: #64748b;
  font-size: 0.9rem;
}

/* Error States */
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  gap: 1rem;
  text-align: center;
}

.error-message {
  color: #dc2626;
  font-size: 0.9rem;
  margin: 0;
}

.retry-button {
  padding: 0.5rem 1rem;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background 0.2s;
}

.retry-button:hover {
  background: #5a67d8;
}

/* Responsive Design */
@media (max-width: 768px) {
  .profile-page {
    padding: 1rem;
  }
  
  .profile-header {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }
  
  .avatar-large {
    width: 80px;
    height: 80px;
  }
  
  .avatar-letter {
    font-size: 2rem;
  }
  
  .streak-section {
    grid-template-columns: 1fr;
  }
  
  .info-grid {
    grid-template-columns: 1fr;
  }
  
  .edit-actions {
    flex-direction: column;
  }
}

/* Special gradient for main hero title */
.purple-gradient-text {
  background: linear-gradient(135deg, #7b3dd8 0%, #5707ab 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: inline-block;
} `, "",{"version":3,"sources":["webpack://./src/components/ProfilePage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,iDAAiD;EACjD,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,qCAAqC;EACrC,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gDAAgD;EAChD,yBAAyB;EACzB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,yCAAyC;AACzC;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;AACvB","sourcesContent":[".profile-page {\n  min-height: 100vh;\n  background: #0A0A1B;\n  padding: 2rem;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.profile-container {\n  max-width: 800px;\n  margin: 0 auto;\n  background: transparent;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n}\n\n/* Profile Header */\n.profile-header {\n  display: flex;\n  align-items: center;\n  padding: 2rem;\n  background: rgba(255, 255, 255, 0.05);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  gap: 1.5rem;\n  backdrop-filter: blur(10px);\n}\n\n.avatar-large {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  background: #667eea;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  border: 3px solid white;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.avatar-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 50%;\n}\n\n.avatar-letter {\n  color: white;\n  font-size: 2.5rem;\n  font-weight: 600;\n}\n\n.user-info {\n  flex: 1;\n}\n\n.user-name {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0;\n  background: linear-gradient(135deg, #7b3dd8 0%, #667eea 50%, #5606aa 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  letter-spacing: -0.02em;\n}\n\n.user-email {\n  color: #94a3b8;\n  font-size: 0.9rem;\n}\n\n/* Edit Controls */\n.edit-controls {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.edit-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.75rem;\n  background: transparent;\n  color: #94a3b8;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.2s;\n  width: 44px;\n  height: 44px;\n}\n\n.edit-button:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #f1f5f9;\n  transform: scale(1.05);\n}\n\n.edit-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.save-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.6rem 1.2rem;\n  background: #10b981;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  font-weight: 500;\n  transition: all 0.2s;\n  min-width: 80px;\n}\n\n.save-button:hover:not(:disabled) {\n  background: #059669;\n  transform: translateY(-1px);\n}\n\n.save-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.cancel-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.6rem 1.2rem;\n  background: #64748b;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  font-weight: 500;\n  transition: all 0.2s;\n  min-width: 80px;\n}\n\n.cancel-button:hover {\n  background: #475569;\n  transform: translateY(-1px);\n}\n\n/* Streak Section */\n.streak-section {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n  padding: 2rem;\n  background: rgba(255, 255, 255, 0.03);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.streak-card {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n}\n\n.streak-icon {\n  width: 24px;\n  height: 24px;\n  color: #667eea;\n}\n\n.streak-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.streak-number {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #f1f5f9;\n  line-height: 1;\n}\n\n.streak-label {\n  color: #94a3b8;\n  font-size: 0.8rem;\n}\n\n/* Info Section */\n.info-section {\n  padding: 2rem;\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.info-section h2 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin: 0 0 1rem;\n  background: linear-gradient(135deg, #7b3dd8 0%, #667eea 50%, #5606aa 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  letter-spacing: -0.01em;\n}\n\n.info-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n}\n\n.info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.info-label {\n  font-size: 0.8rem;\n  color: #94a3b8;\n  font-weight: 500;\n}\n\n.info-value {\n  color: #f1f5f9;\n  font-weight: 500;\n}\n\n/* Edit Form */\n.edit-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.form-group label {\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #94a3b8;\n}\n\n.form-input {\n  padding: 0.75rem;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 6px;\n  font-size: 0.9rem;\n  transition: border-color 0.2s;\n  background: rgba(255, 255, 255, 0.05);\n  color: #f1f5f9;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.form-input::placeholder {\n  color: #64748b;\n}\n\n.readonly-input {\n  background: rgba(255, 255, 255, 0.02) !important;\n  color: #94a3b8 !important;\n  cursor: not-allowed;\n  border-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n/* Loading States */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  gap: 1rem;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #e2e8f0;\n  border-top: 3px solid #667eea;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loading-text {\n  color: #64748b;\n  font-size: 0.9rem;\n}\n\n/* Error States */\n.error-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  gap: 1rem;\n  text-align: center;\n}\n\n.error-message {\n  color: #dc2626;\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n.retry-button {\n  padding: 0.5rem 1rem;\n  background: #667eea;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background 0.2s;\n}\n\n.retry-button:hover {\n  background: #5a67d8;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .profile-page {\n    padding: 1rem;\n  }\n  \n  .profile-header {\n    flex-direction: column;\n    text-align: center;\n    gap: 1rem;\n  }\n  \n  .avatar-large {\n    width: 80px;\n    height: 80px;\n  }\n  \n  .avatar-letter {\n    font-size: 2rem;\n  }\n  \n  .streak-section {\n    grid-template-columns: 1fr;\n  }\n  \n  .info-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .edit-actions {\n    flex-direction: column;\n  }\n}\n\n/* Special gradient for main hero title */\n.purple-gradient-text {\n  background: linear-gradient(135deg, #7b3dd8 0%, #5707ab 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  display: inline-block;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
